/* eslint-disable @typescript-eslint/no-unused-vars */
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, Grid,  InputLabel,  LinearProgress,  MenuItem,  Paper, Select, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { useState } from 'react';
import { AutoCompleteFazenda01, AutoCompletePatrimonio01 } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { RelatorioEstoqueService } from '../../../shared/services/api/estoque/Relatorios/RelatoriosService';
import { PatrimoniosService } from '../../../shared/services/api/cadastros/PatrimoniosService';
import ROs from './ROs';

export const RelatorioaOs: React.FC = () => {
        
  const [isLoading, setIsLoading] = useState(false);          
  const [uidfazenda, setUidFazenda] = useState('');    
  const [fazenda, setFazenda] = useState('');            
  const [tipo, setTipo] = useState('fazenda');      
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs());      
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());      
  const [texto, setTexto] = useState('');   
  const [idpatrimonio, setIdPatrimonio] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
             
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,                
    reason?: SnackbarCloseReason,     
  ) => {       
    if (reason === 'clickaway') {          
      return;                   
    }      
    setOpenmsg(false);                
  };      
       
  const handleVisualizar = () => {                 
    setIsLoading(true);
    let filter;
    if(tipo === 'fazenda'){
      setTexto(`Fazenda: ${fazenda} Período: ${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);
      filter = uidfazenda;
    }else if(tipo === 'data'){
      setTexto(`Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);
    }else{
      setTexto(`Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`); 
      filter = idpatrimonio;
    }
    RelatorioEstoqueService
      .Os(filter, tipo, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {     
          setTms('error');                                       
          setMsg(result.message);                               
          setOpenmsg(true);                         
        } else {                                                                          
          if(result.length > 0){                                                         
            ROs(result, texto);                                               
          }else{                                              
            setTms('warning');                        
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);
          }                            
        }          
      });       
  };     

  const handleFazenda = (uuidfazenda: string | undefined) => {
    if (uuidfazenda != null) {
      setUidFazenda(uuidfazenda);
    }else{
      setUidFazenda('');
    }           
  };

  const handleFazendaNome = (pfazenda: string | undefined) => {
    if (pfazenda != null) {
      setFazenda(pfazenda);
    }else{
      setUidFazenda('');
    }           
  };


  const handlepatrimonio = (fidpatrimonio: string | undefined) => {    
    if (fidpatrimonio != null) {        
      setIdPatrimonio(fidpatrimonio);                        
    }else{                           
      setIdPatrimonio('');                                      
    }                          
  };  

  return (
    <Box  alignItems="center" width='100%' alignContent='center' height="50%"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1}  display="flex" alignItems="center" alignSelf='center' width='80%' height="80%" margin={1}  alignContent='center'></Box>
      <Grid container spacing={1} item direction="row" xs={12} sm={12} md={12} lg={7} xl={5.5}>
        <Box   width='auto'  component={Paper} >       
          <DialogTitle>Relatório de Ordem de Serviço</DialogTitle>
          <DialogContent  dividers>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid> 
            )}    
            <Grid container item direction="row">
              <Grid container spacing={1} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>   
                  <FormControl fullWidth >
                    <InputLabel id="demo-simple-select-label">{'Tipo'}</InputLabel>
                    <Select
                      fullWidth
                      size='small'     
                      value={tipo}
                      label='tipo'
                      onChange={(event) => setTipo(event.target.value)}
                    >
                      <MenuItem value={'data'}>Data</MenuItem>
                      <MenuItem value={'fazenda'}>Fazenda</MenuItem>
                      <MenuItem value={'patrimonio'}>Patrimonio</MenuItem>
                    </Select>  
                  </FormControl>         
                </Grid> 
                <Grid item xs={8} sm={8} md={4} lg={9} xl={9}>     
                  <AutoCompletePatrimonio01        
                    idpatrimonio={handlepatrimonio}    
                  />      
                </Grid>
                <Grid item xs={10} sm={10} md={10} lg={12} xl={12}>
                  <AutoCompleteFazenda01
                    uuidfazenda={handleFazenda} 
                    nome={handleFazendaNome}
                  />          
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format='DD/MM/YYYY'  
                      value={dataInicial}
                      onChange={(newValue) => setDataInicial(newValue)} 
                      slotProps={{
                        textField: {    
                          size:'small',
                        }
                      }}
                    />
                  </LocalizationProvider>     
                </Grid>  
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format='DD/MM/YYYY'
                      value={dataFinal}
                      onChange={(newValue) => setDataFinal(newValue)}  
                      slotProps={{
                        textField: {    
                          size:'small',
                        }
                      }}
                    />
                  </LocalizationProvider>   
                </Grid>           
              </Grid>     
            </Grid>
          </DialogContent>  
          <DialogActions>
            <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleVisualizar}>Visualizar</Button>
          </DialogActions>
        </Box>
      </Grid>
    </Box>
  );
};